import Immutable from 'seamless-immutable';
import _ from 'lodash';
import {
  createField,
  createValidateObject,
  getForm,
  storeSetFieldsErrors
} from '../../../../../utils/reducerHalpers/formFields';
import * as validateTypes from '../../../../../utils/reducerHalpers/validateTypes';
import {
  createRequestState,
  setRequestStateFinish,
  setRequestStateInProgress
} from '../../../../../utils/reducerHalpers/requestState';

const INIT_STATE = 'INIT_STATE';
const REQUEST_FINISHED = 'REQUEST_FINISHED';
const SEND_REQUEST = 'SEND_REQUEST';
const SET_ERRORS = 'SET_ERRORS';
const CLEAR_ALL_ERRORS = 'CLEAR_ALL_ERRORS';
const CHANGE_FIELD_AVATAR_FILE = 'CHANGE_FIELD_AVATAR_FILE';
const DELETE_AVATAR = 'DELETE_AVATAR';

const createActionName = (reducerName, name) => `app/${reducerName}/${name}`;
export const getState = (state, reducerName) => _.get(state, reducerName);

const createReducer = name => {
  function stateDefault() {
    return {
      ...createRequestState(),
      fields: {
        ...createField({
          field: 'avatarFile',
          title: 'Аватар',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)],
          errors: []
        })
      }
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(name, INIT_STATE):
        return Immutable(stateDefault());
      case createActionName(name, REQUEST_FINISHED):
        return setRequestStateFinish(
          state,
          action.payload.codeResponse,
          action.payload.hasSuccess
        );
      case createActionName(name, SEND_REQUEST):
        return setRequestStateInProgress(state);
      case createActionName(name, SET_ERRORS):
        return storeSetFieldsErrors(state, action.payload);
      case createActionName(name, CLEAR_ALL_ERRORS):
        return state.merge({
          errors: {}
        });

      // FIELDS
      case createActionName(name, CHANGE_FIELD_AVATAR_FILE): {
        const fields = Immutable.asMutable(state.fields, { deep: true });
        fields.avatarFile.value = action.payload;
        const v = state.merge({
          fields
        });
        return v;
      }
      default:
        return state;
    }
  };
};

export function createReduceObject(combineName, reducerName) {
  const reduceObject = {};
  reduceObject[reducerName] = createReducer(`${combineName}.${reducerName}`);
  return reduceObject;
}

// ACTIONS
export const initState = reducerName => ({
  type: createActionName(reducerName, INIT_STATE)
});
export const requestFinished = (reducerName, codeResponse, hasSuccess) => ({
  type: createActionName(reducerName, REQUEST_FINISHED),
  payload: { codeResponse, hasSuccess }
});
export const sendRequest = (reducerName, payload) => ({
  type: createActionName(reducerName, SEND_REQUEST),
  payload
});
export const setErrors = (reducerName, payload) => ({
  type: createActionName(reducerName, SET_ERRORS),
  payload
});
export const clearAllErrors = (reducerName, payload) => ({
  type: createActionName(reducerName, CLEAR_ALL_ERRORS),
  payload
});
export const changeFieldAvatarFile = (reducerName, payload) => ({
  type: createActionName(reducerName, CHANGE_FIELD_AVATAR_FILE),
  payload
});
export const deleteAvatar = reducerName => ({
  type: createActionName(reducerName, DELETE_AVATAR)
});

// SELECTORS
export const selectFormBody = (state, reducerName) =>
  getForm(getState(state, reducerName));
export const selectRequestState = (state, reducerName) =>
  _.get(getState(state, reducerName), 'requestState');
export const selectFieldAvatarFile = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.avatarFile');



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/common/reducers/forms/avatarForm.js